import React from "react";
import { Badge, colors } from "../design/badge";
import { Intake } from "../models/Intake";

interface IntakeStatusBadgeProps {
  status: Intake["status"];
}

const IntakeStatusBadge: React.FC<IntakeStatusBadgeProps> = ({ status }) => {
  let color;
  let title;

  switch (status) {
    case "initiated":
      color = "blue";
      title = "Initiated";
      break;
    case "processing":
      color = "yellow";
      title = "Processing";
      break;
    case "matter_created":
      color = "purple";
      title = "Matter Created";
      break;
    case "completed":
      color = "green";
      title = "Completed";
      break;
    case "error":
      color = "red";
      title = "Error";
      break;
    default:
      color = "yellow"; // Default color if status is unknown
      title = status;
  }

  return <Badge color={color as keyof typeof colors}>{title}</Badge>;
};

export default IntakeStatusBadge;
